// ============================================================================
// Assurance - Page Interruption (conteneur)
// Affiche directement la page InterruptionSouscriptions
// ============================================================================

import InterruptionSouscriptions from './InterruptionSouscriptions';

const InterruptionPage = () => {
  return <InterruptionSouscriptions />;
};

export default InterruptionPage;
